import CardHeader from "../../antd/components/CardHeader";
import { useEffect, useState } from "react";
import { GetAllCompanyFinep } from "../../API/CompanyFinepAPI";
import { PersonaCompanyCard } from "../../Components/PersonaCompanyFinep/PersonaCompanyCard";
import { PersonaCompanyCreateCard } from "../../Components/PersonaCompanyFinep/PersonaCompanyCreateCard";
import { GetAllPersonaFinep } from "../../API/PersonaFinepAPI";
import { PersonaFinepModel } from "../../Models/PersonaFinepModel";
import { CompanyFinepCardModel } from "../../Models/CompanyFinepModel";
import Loader from "../../Components/Shared/Loader";
import { useParams } from "react-router-dom";

const PersonaAndCompanyFinep = () => {
    const [persons, setPersons] = useState<PersonaFinepModel[]>([]);
    const [companies, setCompanies] = useState<CompanyFinepCardModel[]>([]);
    const [loading, setLoading] = useState(false);
    const { registerId, id} = useParams();

    async function GetPersons() {
        setLoading(true);
        const result = await GetAllPersonaFinep(registerId ?? "");
        setPersons(result);
        setLoading(false);
    }

    async function GetCompanies() {
        setLoading(true);
        const result = await GetAllCompanyFinep(registerId ?? "");
        setCompanies(result);
        setLoading(false);
    }

    useEffect(() => {
        GetPersons();
        GetCompanies();
    }, []);


    return (
        <>
        {loading && <Loader />}
            <div className='card ml-2 mr-2'>
                <CardHeader
                    pageName={"Cadastro de Pessoa Física e Jurídica"}
                    hasPageBefore={true}
                    linkPageBefore={`/registrationFinep/${registerId}/${id}`}
                    pageBeforeName={"Cadastro Finep"}
                />
                <div className='card-body'>
                    <div className='d-flex flex-wrap wrap p-4'>
                        {persons.map((person) => {
                            return (
                                <PersonaCompanyCard
                                    key={person.id}
                                    id={person.id}
                                    document={person.fullname ?? ""}
                                    type={'Natural'}
                                    getPersons={GetPersons}
                                />
                            )
                        })}

                        {companies.map((company) => {
                            return (
                                <PersonaCompanyCard
                                    key={company.id}
                                    id={company.id}
                                    document={company.cnpj}
                                    type={'Legal'}
                                    getPersons={GetPersons}
                                />
                            )
                        })}

                        <PersonaCompanyCreateCard
                            type="Legal"
                            getPersons={GetPersons}
                        />
                        {
                            persons && persons.length >= 1
                                ?
                                null
                                :
                                <PersonaCompanyCreateCard
                                    type="Natural"
                                    getPersons={GetPersons}
                                />
                        }

                    </div>
                </div>
            </div>
        </>
    );
}

export default PersonaAndCompanyFinep;